import styled from 'styled-components';

// Components
import { DropDownSelect } from '../../../../components/inputs/DropDown/DropDownSelect';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spaces.xl}rem;
  @media (max-width: ${({ theme }) => theme.breakPoints.smallDesktop * theme.percentBaseResponsive}rem) {
    gap: ${({ theme }) => theme.spaces.m}rem;
  }
  @media (max-width: ${({ theme }) => theme.breakPoints.landscapeTablet *
    theme.percentBaseResponsive}rem) {
    flex-direction: column;
  }
`;

export const SubContainer = styled.div`
  display: flex;
  gap: ${({ theme }) => theme.spaces.xl}rem;
  @media (max-width: ${({ theme }) => theme.breakPoints.smallDesktop * theme.percentBaseResponsive}rem) {
    flex-direction: column;
    gap: 0;
  }
`;

export const NavContainer = styled.div`
  display: flex;
  flex-direction: column;
  min-width: 36rem;
  position: relative;
  gap: ${({ theme }) => theme.spaces.m}rem;
`;

export const DropDownSelectStyled = styled(DropDownSelect)``;
